<template>
  <div>
    <van-sticky @scroll="stickyChange" :class="stickyChangeFlag ? 'stickyBottom' : ''">
      <!-- <van-nav-bar title="订单" left-text="返回" left-arrow @click-left="onClickLeft"/> -->
      <div class="box">
        <div class="tab" @click="changeTabs('a')"><p>充值订单</p><div class="tabsLine" :class="tabsName === 'a' ? '' : 'none'"></div></div>
        <div class="tab" @click="changeTabs('b')"><p>流量包订单</p><div class="tabsLine" :class="tabsName === 'b' ? '' : 'none'"></div></div>
      </div>
      <van-cell v-show="tabsName === 'a'" size="large">
        <template #title>
          <p>交易时间：{{orderDate.currentDate}}</p>
          <div class="icon">
            <van-icon name="calendar-o" @click="openTimeChanges('recharge')"/>
            <van-icon name="replay" @click="replay('recharge')" />
          </div>
        </template>
      </van-cell>
      <van-cell v-show="tabsName === 'b'" size="large">
        <template #title>
          <p>交易时间：{{orderDates.currentDate}}</p>
          <div class="icon">
            <van-icon name="calendar-o" @click="openTimeChanges('flow')"/>
            <van-icon name="replay" @click="replay('flow')" />
          </div>
        </template>
      </van-cell>
    </van-sticky>
    <van-tabs v-model='tabsName' >
      <van-tab name="a" title="充值订单">
        <!--日期选择-->
        <van-action-sheet v-model="orderDate.isSelect">
          <van-datetime-picker
            v-model="czCurrentDate"
            type="date"
            title="选择年月日"
            @confirm="getTime"
          />
        </van-action-sheet>
        <!--订单信息-->
        <VANABS :paramsList=paramsList :orderKey="title" @change = changeList :list="list"></VANABS>
        <div v-show="loadingShow" class="loading">
          <van-loading type="spinner" vertical>加载中...</van-loading>
        </div>
      </van-tab>
      <van-tab name="b" title="流量包订单">
        <!--日期选择-->
        <van-action-sheet v-model="orderDates.isSelect">
          <van-datetime-picker
            v-model="llCurrentDate"
            type="date"
            title="选择年月日"
            @confirm="getTime"
          />
        </van-action-sheet>
        <!--订单信息-->
        <VANABS :paramsList=paramsLists :orderKey="title" @change = changeLists :list="lists"></VANABS>
        <div v-show="loadingShows" class="loading">
          <van-loading type="spinner" vertical>加载中...</van-loading>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import VANABS from '@/components/OrderVanTab'
import { saleOrder, flowAddOrder } from '@/api/user.js'
export default {
  components: { VANABS },
  props: {},
  data () {
    return {
      // 充值查询时间
      orderDate: {
        currentDate: new Date().getFullYear() + '年' + (new Date().getMonth() * 1 + 1) + '月' + new Date().getDate() + '日',
        isSelect: false
      },
      // 流量查询时间
      orderDates: {
        currentDate: new Date().getFullYear() + '年' + (new Date().getMonth() * 1 + 1) + '月' + new Date().getDate() + '日',
        isSelect: false
      },
      // 充值时间默认值
      czCurrentDate: new Date(),
      // 流量时间默认值
      llCurrentDate: new Date(),
      title: '充值',
      tabsName: 'a',
      stickyChangeFlag: false,
      paramsList: {
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0] + '',
        page: 1,
        limit: 10,
        endRechargeDate: ''
      },
      paramsLists: {
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0],
        page: 1,
        limit: 10,
        endRechargeDate: ''
      },
      list: [],
      lists: [],
      // list是否有数
      loadingShow: false,
      loadingShows: false
    }
  },
  watch: {},
  computed: {},
  methods: {
    // onClickLeft () { this.$router.go(-1) },
    getTime (val) {
      window.scrollTo(0, 0)
      this.paramsList.page = 1
      this.paramsList.endRechargeDate = val.getFullYear() + '-0' + (val.getMonth() + 1) + '-' + val.getDate()
      if (this.tabsName === 'a') {
        this.orderDate.currentDate = val.getFullYear() + '年' + (val.getMonth() + 1) + '月' + (val.getDate()) + '日'
        this.orderDate.isSelect = false
        this.rechargeOrder()
      } else {
        this.orderDates.currentDate = val.getFullYear() + '年' + (val.getMonth() + 1) + '月' + (val.getDate()) + '日'
        this.orderDates.isSelect = false
        this.flowOrder()
      }
    },
    async rechargeOrder () {
      this.loadingShow = true
      this.list = []
      const { data: res } = await saleOrder(this.paramsList)
      // res.extend.rows.forEach(item => {
      //   item.recharge_date = item.recharge_date.split('T')[0] + ' ' + item.recharge_date.split('T')[1].split('.')[0]
      // })
      this.list = res.extend.rows
      if (res.extend.rows && res.extend.rows.length >= this.paramsList.limit) {
        // 更新获取下一次数据的时间戳
        this.paramsList.page++
      }
      this.$nextTick(_ => {
        this.loadingShow = false
      })
    },
    async flowOrder () {
      this.loadingShows = true
      this.lists = []
      const { data: res } = await flowAddOrder(this.paramsList)
      // res.extend.rows.forEach(item => {
      //   item.rechargeDate = item.rechargeDate.split('T')[0] + ' ' + item.rechargeDate.split('T')[1].split('.')[0]
      // })
      this.lists = res.extend.rows
      if (res.extend.rows && res.extend.rows.length >= this.paramsList.limit) {
        // 更新获取下一次数据的时间戳
        this.paramsLists.page++
      }
      this.$nextTick(_ => {
        this.loadingShows = false
      })
    },
    changeList (e) {
      if (e.type === 'add') {
        this.list.push(...e.list)
      } else {
        this.list = []
      }
    },
    changeLists (e) {
      if (e.type === 'add') {
        this.lists.push(...e.list)
      } else {
        this.lists = []
      }
    },
    changeTabs (e) {
      this.tabsName = e
      if (e === 'a') {
        this.title = '充值'
      } else {
        this.title = '流量'
      }
    },
    stickyChange (e) {
      this.stickyChangeFlag = e.isFixed
    },
    // 重置时间查询
    replay (e) {
      const that = this
      this.$dialog.confirm({
        title: '温馨提示',
        message: '是否重置查询时间'
      }).then(async () => {
        window.scrollTo(0, 0)
        if (e === 'flow') {
          that.flowReplay()
        } else {
          that.rechargeReplay()
        }
        // on close
      }).catch(() => {
        this.$toast('取消重置')
      })
    },
    async flowReplay () {
      this.llCurrentDate = new Date()
      this.loadingShows = true
      this.lists = []
      this.paramsLists.endRechargeDate = ''
      this.paramsLists.page = 1
      this.orderDates.currentDate = new Date().getFullYear() + '年' + (new Date().getMonth() * 1 + 1) + '月' + new Date().getDate() + '日'
      const { data: res } = await flowAddOrder(this.paramsLists)
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast.fail('请重新登录')
      }
      // res.extend.rows.forEach(item => {
      //   item.rechargeDate = item.rechargeDate.split('T')[0] + ' ' + item.rechargeDate.split('T')[1].split('.')[0]
      // })
      this.lists = res.extend.rows
      if (res.extend.rows && res.extend.rows.length >= this.paramsList.limit) {
        // 更新获取下一次数据的时间戳
        this.paramsLists.page++
      }
      this.$nextTick(_ => {
        this.loadingShows = false
      })
    },
    async rechargeReplay () {
      this.czCurrentDate = new Date()
      this.loadingShow = true
      this.list = []
      this.paramsList.endRechargeDate = ''
      this.paramsList.page = 1
      this.orderDate.currentDate = new Date().getFullYear() + '年' + (new Date().getMonth() * 1 + 1) + '月' + new Date().getDate() + '日'
      const { data: res } = await saleOrder(this.paramsList)
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast.fail('请重新登录')
      }
      // res.extend.rows.forEach(item => {
      //   item.recharge_date = item.recharge_date.split('T')[0] + ' ' + item.recharge_date.split('T')[1].split('.')[0]
      // })
      this.list = res.extend.rows
      if (res.extend.rows && res.extend.rows.length >= this.paramsList.limit) {
        // 更新获取下一次数据的时间戳
        this.paramsList.page++
      }
      this.$nextTick(_ => {
        this.loadingShow = false
      })
    },
    openTimeChanges (e) {
      if (e === 'flow') {
        this.orderDates.isSelect = true
      } else {
        this.orderDate.isSelect = true
      }
    }
  },
  beforeCreate () {},
  created () {
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  /deep/.van-cell__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      margin-left: 15px;
    }
    .icon {
      font-size: 36px;
      width: 100px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }
  }
  /deep/.ve-table-body-tr,
  /deep/.ve-table-header-tr {
    height: 120px!important;
  }
  /deep/.ve-table-body-td,
  /deep/.ve-table-header-th {
    font-size: 25px!important;
  }
  /deep/.van-tabs__wrap {
    display: none;
    height: 0;
  }
  .ve-table {
    border-bottom: 1px solid #eeeeee;
  }
  .box {
    height: 100px;
    display: flex;
    justify-content: space-around;
    background-color: #fff;
    .tab{
      text-align: center;
      font-size: 0.37333rem;
      line-height: 100px;
      position: relative;
      margin-left: 15px;
    }
    .tabsLine {
      position: absolute;
      bottom: 0.08rem;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
      width: 1.06667rem;
      height: 0.08rem;
      background-color: #ee0a24;
    }
    .none {
      display: none;
    }
  }
  .stickyBottom {
    /deep/.van-sticky {
      border-bottom: 1px solid #f3f3f3;
    }
  }
  .noList {
    margin-top: 15px;
    text-align: center;
    .title {
      font-size: 30px;
      color: rgb(184, 184, 184);
    }
  }
  .loading {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 300%)
  }
</style>
